/** Config / tenant domain query segments */
export const ConfigQueryKeys = {
  tenant: {
    all: ['static/tenant'] as const,
  },
};
